import formatMessage from 'format-message';

/**
 * Nadpisy sekcií v palete robotích blokov.
 *
 * scratch-vm vie do palety rozšírenia vložiť len prázdnu medzeru ('---'),
 * takže 48 blokov tvorí jeden neprehľadný stĺpec. scratch-blocks pritom
 * textové nadpisy podporuje (<label>, používa ho napr. micro:bit pre stavový
 * riadok) — len sa k nim cez getInfo() nedá dostať. Preto sa nadpisy vkladajú
 * až do hotového XML kategórie: pred prvý blok a za každý oddeľovač '---'.
 *
 * Poradie tu musí sedieť s poradím sekcií (oddeľovačov '---') v index.js —
 * stráži to test reachy-sections.test.js.
 */

const SECTIONS = [
    ['head', 'Head'],
    ['body', 'Body'],
    ['antennas', 'Antennas'],
    ['voice', 'Voice'],
    ['emotions', 'Emotions and dance'],
    ['eyes', 'Eyes (camera)'],
    ['ears', 'Ears (microphone)'],
    ['basics', 'Basics']
];

/** Presný tvar, na ktorý scratch-vm prekladá '---' (runtime.js). */
const SEPARATOR_XML = '<sep gap="36"/>';

const escapeXml = text => String(text)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');

const sectionTitles = () => SECTIONS.map(([key, def]) => formatMessage({
    id: `reachy.section.${key}`,
    default: def,
    description: `Reachy palette section header: ${def}`
}));

const labelXml = title => `<label text="${escapeXml(title)}"/>`;

/**
 * Doplň nadpisy sekcií do XML kategórie reachyBlocks.
 *
 * Volať na surový výstup runtime.getBlocksXML(), pred úpravou tém — tá XML
 * reserializuje a oddeľovač by už nemusel sedieť znak po znaku.
 * @param {Array.<{id: string, xml: string}>} dynamicBlockXML - výstup getBlocksXML()
 * @returns {Array.<{id: string, xml: string}>} to isté, s nadpismi v reachyBlocks
 */
const injectReachySectionLabels = dynamicBlockXML => dynamicBlockXML.map(category => {
    if (category.id !== 'reachyBlocks') return category;
    const parts = category.xml.split(SEPARATOR_XML);
    // Keby počet sekcií nesedel s paletou, radšej bez nadpisov než rozbité.
    if (parts.length !== SECTIONS.length) return category;
    const titles = sectionTitles();
    const xml = parts
        .map((part, i) => {
            if (i === 0) {
                // Prvý nadpis patrí hneď za otvárací <category ...>.
                return part.replace(/<category[^>]*>/, open => open + labelXml(titles[0]));
            }
            return SEPARATOR_XML + labelXml(titles[i]) + part;
        })
        .join('');
    return {id: category.id, xml};
});

export {SECTIONS, injectReachySectionLabels};
